import { FC, useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { MainLayout } from 'views/layouts'
import TitleDiv from 'views/components/UI/TitleDiv'
import { StrokedButton } from 'views/components/UI/Buttons';
import { cleanDataNewQuestionnaire } from 'ducks/modules'
import { ActionEditQuestionnaire } from 'views/components/UI/BluesiteTable/Actions/GridActions'
import BluesiteTableComponent from 'views/components/UI/BluesiteTable'
import axios from 'lib/axios'
import { specialAdminRoutes } from 'router/routes'
import { TEST_HEADERS } from './constants'
import { useNotification } from 'lib/context/notification.context'

const QUESTIONNAIRE_ADMIN_ROLES = new Set([
  'special_admin',
  'super_admin',
  'platform_admin',
  'super_platform_admin',
])

const QuestionariesBetesa: FC = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { getError, getWarning } = useNotification()
  const role = useSelector((state: any) => state.auth.role)
  const { hasQuestionnaireManagement } = useSelector((state: any) => state.user)
  const canManageQuestionnaires =
    QUESTIONNAIRE_ADMIN_ROLES.has(role) &&
    hasQuestionnaireManagement === true
  const canCreateQuestionnaire = canManageQuestionnaires


  const [questionarys, setQuestionarys] = useState<any>([])
  const [searchParam, setSearchParam] = useState('');
  const [totalPages, setTotalPages] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)


  const handleShowAll = useCallback(async (page = 1, limit = 10) => {
    try {
      const response = await axios.get('/company-questionnaire', {
        params: {
          page,
          limit,
          search: searchParam || undefined,
        },
      })

      const questionnaires = response?.data?.questionnaires || []

      setQuestionarys(
        questionnaires.map((questionnaire: any) => ({
          id: questionnaire.id,
          skill: questionnaire.name,
          can_edit: questionnaire.can_edit !== false,
          onNoEditAccess: () =>
            getWarning('No puedes editar este cuestionario'),
        })),
      )
      setTotalPages(response?.data?.total_pages || 1)
      setCurrentPage(page)
    } catch (error: any) {
      setQuestionarys([])
      setTotalPages(1)
      getError(
        error?.response?.data?.message ||
          'No fue posible cargar los cuestionarios',
      )
    }
  }, [getError, getWarning, searchParam])

  useEffect(() => {
    if (!canManageQuestionnaires) {
      getWarning('Comunicate con el administrador.')
      navigate('/', { replace: true })
      return
    }

    handleShowAll()
    dispatch(cleanDataNewQuestionnaire())
  }, [canManageQuestionnaires, dispatch, getWarning, handleShowAll, navigate])

  const handleNewQuestionnaire = () => {
    if (!canCreateQuestionnaire) {
      getWarning('Comunicate con el administrador.')
      return
    }

    navigate(specialAdminRoutes.NewQuestionnaireBetesa)
  }


  return (
    <MainLayout>
      <TitleDiv>
        <h2 style={{ fontSize: 32 }}>Cuestionarios</h2>
        {canCreateQuestionnaire ? (
          <StrokedButton onClick={handleNewQuestionnaire}>
            Nuevo cuestionario
          </StrokedButton>
        ) : null}
      </TitleDiv>
      <div style={{ padding: '20px 0px' }}>
        <BluesiteTableComponent
          ActionComponent={ActionEditQuestionnaire}
          data={questionarys}
          headers={TEST_HEADERS}
          currentPage={currentPage}
          searchBar={false}
          totalPages={totalPages}
          setSearchParam={setSearchParam}
          handlePagination={handleShowAll}
          handleSearchFunction={() => handleShowAll()}
          searchLabel='' />
      </div>
    </MainLayout>
  )
}

export default QuestionariesBetesa
